import { useCallback, useState, useEffect } from 'react';

import { useIsEditorToolbarDockedAtTop } from '@confluence/content-types-header';
import { fg } from '@confluence/feature-gating';

import {
	getBannerType,
	isBannerDismissedInLocalStorage,
	persistBannerDismissal,
	persistBannerDismissalNewPinning,
	isBannerDismissedInLocalStorageNewPinning,
} from '../EditorControlsBannerDismissal';
import { getStorageObject } from '../EditorControlsBanner';

export const useIsControlsBannerDismissed = (isLivePage: boolean) => {
	const isEditorToolbarDockedAtTop = useIsEditorToolbarDockedAtTop({
		defaultDockedAtTop: !isLivePage,
	});

	const bannerType = getBannerType(isEditorToolbarDockedAtTop);

	const [isControlsBannerDismissed, setIsControlsBannerDismissed] = useState(() => {
		if (fg('platform_update_onboarding_banner_fully_dimissed')) {
			return isBannerDismissedInLocalStorageNewPinning(bannerType);
		} else if (fg('platform_editor_controls_new_dimissal_logic_copy')) {
			return isBannerDismissedInLocalStorage(bannerType);
		}
		return getStorageObject(isLivePage).isDismissed;
	});

	useEffect(() => {
		if (fg('platform_update_onboarding_banner_fully_dimissed')) {
			setIsControlsBannerDismissed(isBannerDismissedInLocalStorageNewPinning(bannerType));
		} else if (fg('platform_editor_controls_new_dimissal_logic_copy')) {
			setIsControlsBannerDismissed(isBannerDismissedInLocalStorage(bannerType));
		}
	}, [bannerType]);

	const onDismiss = useCallback(() => {
		setIsControlsBannerDismissed(true);
		if (fg('platform_update_onboarding_banner_fully_dimissed')) {
			persistBannerDismissalNewPinning(bannerType);
		} else if (fg('platform_editor_controls_new_dimissal_logic_copy')) {
			persistBannerDismissal(bannerType);
		}
	}, [bannerType]);

	return { isControlsBannerDismissed, onDismiss, bannerType };
};
